import {InfiniteData, useMutation, useQueryClient} from '@tanstack/react-query'
import {saveGoal} from '../services/goal.http'
import {QUERY_KEYS} from './keys'
import {ResponseActiveGoalsList} from '../types'

export const useSaveGoalV3 = (goalId: string) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () => saveGoal(goalId),
        onSuccess: goal => {
            queryClient.setQueriesData({queryKey: [QUERY_KEYS.selectedGoal, goalId]}, goal)
            queryClient.setQueriesData(
                {queryKey: [QUERY_KEYS.goals_list]},
                (oldDate: InfiniteData<ResponseActiveGoalsList> | undefined) => {
                    if (!oldDate) return oldDate
                    return {
                        ...oldDate,
                        pages: oldDate.pages.map(page => ({
                            ...page,
                            data: page.data.map(goal =>
                                goal.id.toString() === goalId ? {...goal, is_saved: true} : goal
                            )
                        }))
                    }
                }
            )
        }
    })
}
